<template>
  <div v-if="loaded">
    <v-data-table
      v-if="indemnities.length > 0"
      :headers="headers"
      :items="indemnities"
      :pagination.sync="pagination"
      :total-items="total"
      :rows-per-page-items="[10, 20, 30, 50]"
      @update:pagination="updatePagination"
    >
      <template
        slot="items"
        slot-scope="{ item }"
      >
        <td>
          <v-icon
            v-if="item.status == Consts.INDEMNITIES_STATUS.DRAFT"
            color="info"
            title="Waiting"
          >
            mdi-circle-outline
          </v-icon>
          <v-icon
            v-else-if="item.status == Consts.INDEMNITIES_STATUS.IN_PROGRESS"
            color="warning"
            title="Beeing treated"
          >
            mdi-circle-outline
          </v-icon>
          <v-icon
            v-else
            color="success"
            title="Published"
          >
            mdi-circle-outline
          </v-icon>
        </td>
        <td>
          <v-icon
            v-if="
              [Consts.APPLICATION.ALL, Consts.APPLICATION.BEESECURE].includes(
                item.application
              )
            "
            color="black"
            class="mr-1"
            small
          >
            icon-bee48
          </v-icon>
          <v-icon
            v-if="
              [Consts.APPLICATION.ALL, Consts.APPLICATION.FREELANCES].includes(
                item.application
              )
            "
            color="black"
            class="mr-1"
            small
          >
            icon-kayak48
          </v-icon>
        </td>
        <td>{{ item.team ? item.team.name : " - " }}</td>
        <td v-if="!trainer">
          {{ item._user_firstname }} {{ item._user_lastname }}
        </td>
        <td>{{ item.reference ?? "-" }}</td>
        <td>{{ formatDate(item._first_session_date) }}</td>
        <td>{{ formatDate(item._last_session_date) }}</td>
        <td class="txt-right">
          {{ item._number_of_sessions }}
        </td>
        <td class="txt-right">
          {{ numberFormat(item._total_hours) }}
        </td>
        <td class="txt-right">
          {{ numberFormat(item._total_kms) }}
        </td>
        <td class="txt-right">
          {{ numberFormat(item.total_cost) }} €
        </td>
        <td>
          <v-btn
            class="mx-0"
            icon
            @click="show(item)"
          >
            <v-icon>mdi-open-in-new</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <em v-else>No indemnity is available right now for your account</em>
  </div>
</template>

<script>
import DateMixin from "@/mixins/date";
import GlobalMixin from "@/mixins/global";
import Consts from "@/consts";
import Indemnities from "@/api/indemnities";

const formater = new Intl.NumberFormat("fr-FR");

export default {
  mixins: [DateMixin, GlobalMixin],
  props: {
    application: {
      type: Number,
      required: false,
      default: () => Consts.APPLICATION.ALL,
    },
    team: {
      type: [String, Number],
      required: false,
      default: () => null,
    },
    indemnitiesStatus: {
      type: Number,
      default: () => Consts.INDEMNITIES_STATUS.DRAFT,
    },
    userId: {
      type: String,
      default: () => null,
    },
    trainer: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    const headers = [
      { text: "Status", value: "status", width: 30 },
      { text: "Type", value: "application", width: 30 },
      { text: "Team", value: "team.name", width: 200 },
      { text: "Reference", value: "reference" },
      {
        text: "From (oldest session)",
        value: "_first_session_date",
        width: 150,
      },
      { text: "To (latest session)", value: "_last_session_date", width: 150 },
      { text: "Nb. sessions", value: "_number_of_sessions", width: 80 },
      { text: "Total hours", value: "_total_hours", width: 80 },
      { text: "Total kms", value: "_total_kms", width: 80 },
      { text: "Total cost", value: "total_cost", width: 80 },
      { text: "", value: "", width: 80 },
    ];

    if (!this.trainer) {
      headers.splice(3, 0, { text: "Trainer / AS", value: "user.lastname" });
    }

    return {
      indemnities: [],
      headers,
      total: 0,
      pagination: {
        sortBy: this.trainer ? "reference" : "_user_lastname",
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
      },
      lastPagination: null,
      Consts,
      loaded: false,
    };
  },
  mounted() {
    const storedPagination = this.getStoredObject("indemnities.pagination");
    if (storedPagination) {
      this.pagination = storedPagination;
    }
    this.fetch();
  },
  methods: {
    async fetch(from = "local") {
      if (from == "filters") {
        this.pagination.page = 1;
      }

      let params = {};
      if (!this.trainer) {
        const team_id = this.team != 0 ? this.team : [];
        params = Object.assign({}, this.pagination, {
          application: this.application,
          team_id,
          status: this.indemnitiesStatus,
          user_id: this.userId,
        });
      } else {
        params = Object.assign({}, this.pagination, { scope: "focus-on-user" });
      }
      const { data } = await Indemnities.getList(params);
      this.indemnities = data.items;
      this.pagination.totalItems = data.total;
      this.total = data.total;
      if (from == "filters") {
        this.updatePagination(this.pagination, false);
      }
      this.loaded = true;
    },
    updatePagination(pagination, fetch = true) {
      //Très très très galère pour ne pas avoir 50 appels à l'API
      if (
        this.lastPagination &&
        JSON.stringify(pagination) !== JSON.stringify(this.lastPagination)
      ) {
        this.lastPagination = { ...pagination };
        this.setStoredObject("indemnities.pagination", pagination);
        if (fetch) {
          this.fetch();
        }
      }
      if (!this.lastPagination) {
        this.lastPagination = { ...pagination };
      }
    },
    numberFormat(number) {
      return formater.format(number);
    },
    show(item) {
      if (!this.trainer) {
        this.$router.push({
          name: "payments-payments-show",
          params: { id: item.id },
        });
      } else {
        this.$router.push({
          name: "payments-trainers-show",
          params: { id: item.id },
        });
      }
    },
  },
};
</script>

<style scoped lang="sass">
.txt-right
  text-align: right
</style>
